import React, { useEffect, useState, useReducer } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import { initialState, reducer } from "./reducer";
import NotificationView from "./components/View";
import NotificationList from "./components/List";
import Search from "./components/Search";
import NotificationService from '../../services/Election/NotificationService';
import moment from 'moment';
import SimpleHeader from '../../helpers/cards-helper/SimpleHeader';



const MemberNotifications = () => {
    const token = useSelector(state => state.Member.token);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [listRefreshIndex, setListRefreshIndex] = useState(0);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setLoading(true);
        NotificationService.getNotificationsList(token, state.filters)
            .then((response) => {
                const itemsList = response.data.data.map((item) => {
                    return {
                        ...item,
                        title: item?.title,
                        description: item?.description,
                        notification_date: moment(item?.create_date).format("DD-MM-YYYY, HH:mm")
                    };
                });

                const itemsCount = response.data.count;
                const action = {
                    type: "set_items",
                    payload: {
                        items: itemsList,
                        total: itemsCount,
                    },
                };
                dispatch(action);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [token, state.filters, listRefreshIndex]);


    const refreshList = () => {
        setListRefreshIndex((prevState) => prevState + 1);
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <SimpleHeader
                                title={"Njoftime"}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Search
                                dispatch={dispatch}
                                filters={state.filters}
                                searchLoading={loading}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <NotificationList
                                dispatch={dispatch}
                                items={state.items}
                                totalCount={state.totalCount}
                                initialPagination={state.filters.pagination}
                                filters={state.filters}
                                isLoading={loading}
                                onRefreshList={() => refreshList()}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 1 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <NotificationView
                                item={state.itemSelected}
                                dispatch={dispatch}
                            />
                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};


export default MemberNotifications;